/* @jsx h */
import { defineComponent, h, ref } from "vue";
import { RouterLink } from "vue-router";
import { ResponsiveNavbar } from "@lemmonhq/uikit";
import lemmonLogo from "@app/images/branding/lemmon-logo-full.svg?raw";
import { TrackedDesktopNav } from "../LayoutComponents/Navbar/TrackedDesktopNav";
import { GroupNavItems } from "./GroupNavItems";
import { QuickLinks } from "../LayoutComponents/Navbar/QuickLinks";
import { GroupMobileTabBar } from "./GroupMobileTabBar";
import { isMobileTabBarPrototypeEnabled } from "../LayoutComponents/Navbar/mobileTabBarPrototype";
import { useGroupAuth } from "@app/vue/providers/GroupAuth";

export const GroupNavbar = defineComponent({
  name: "GroupNavbar",
  setup() {
    const isOpen = ref(false);
    const useMobileTabBar = isMobileTabBarPrototypeEnabled();
    const { identity } = useGroupAuth();

    return () => (
      <>
        <div class={["flex flex-col", useMobileTabBar ? "max-[698px]:hidden" : ""]}>
          <ResponsiveNavbar
            isOpen={isOpen}
            renderLogo={() => (
              <RouterLink to="/group/dashboard" class="flex items-center">
                <div
                  data-env={(import.meta.env.VITE_ENV as string)?.toLowerCase()}
                  class="logo-container relative"
                  style="height: 25px; width: 100px"
                  v-html={lemmonLogo}
                />
              </RouterLink>
            )}
            renderDesktopNav={() => (
              <TrackedDesktopNav renderItems={() => <GroupNavItems />} />
            )}
            renderMobileNav={() => (
              <div class="flex flex-1 flex-col gap-2">
                <GroupNavItems onNavigate={() => (isOpen.value = false)} />
              </div>
            )}
            renderQuickLinks={() => <QuickLinks mode="group" />}
            rendreMobileShortcuts={() => null}
          />
        </div>

        {useMobileTabBar && identity.value ? <GroupMobileTabBar /> : null}
      </>
    );
  },
});
